import React, {useEffect, useState} from "react";
import { Document, Page, pdfjs } from 'react-pdf';

import { ListGroup, Row, Col } from 'react-bootstrap';
import LoadingComponent from "../components/LoadingComponent";
import {returnPdfUrl} from '../common/api';

const PdfPreviewPartial = ({fileHash, id, language}) => {
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  }, [])

  const onDocumentLoadSuccess = ({ numPages }) => {
    setCurrentPage(1);
    setNumPages(numPages);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < numPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const loadView = (pdfUrl) => {
    return(
      <div className="pdf-preview">
  
      <Row>
        <Col sm={4}><div className="d-grid gap-2"><button className="btn btn-outline-primary" onClick={goToPreviousPage} disabled={currentPage === 1}>Poprzednia strona</button></div> </Col>
        <Col sm={4}><span>Strona <strong>{currentPage} z {numPages}</strong></span></Col>
        <Col sm={4}><div className="d-grid gap-2"><button className="btn btn-outline-primary" onClick={goToNextPage} disabled={currentPage === numPages}>Następna strona</button></div></Col>
      </Row>
      <hr/>
      <Row>
        <Col sm={12}>
          <div style={{ width: '100%', height: '600px', alignItems: 'center', overflowX: 'auto' }}>
            <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess} loading="Trwa ładowanie pliku PDF">
              <Page pageNumber={currentPage} width={900} loading="Trwa ładowanie strony" renderAnnotationLayer={false} renderTextLayer={false}/>
            </Document>
           
          </div>
        </Col>
      </Row>

    </div>
    )
  }

  let view = <LoadingComponent />
  console.log(fileHash);
  if(fileHash !== null){
    let pdfUrl = returnPdfUrl(fileHash, id, language)
    view = loadView(pdfUrl)
  }
  else{
    view = <p>Brak treści do wyświetlenia</p>
  }

  
  
  return(
    <React.Fragment>
      {view}
    </React.Fragment>
  )

}
export default PdfPreviewPartial;